import { Search } from "lucide-react"
import { useTranslations } from "modules/i18n/hooks/useTranslations"
import { useRegionCode } from "modules/i18n/hooks/useRegionCode"
import { pageUrl } from "common/lib/router"
import { useId } from "react"

export const SearchForm = () => {
  const t = useTranslations("layout.header")
  const regionCode = useRegionCode()
  const searchPath = pageUrl.view({ regionCode, pageSlug: "search" })
  const searchInputId = useId()

  return (
    <form
      action={searchPath}
      acceptCharset="UTF-8"
      method="get"
      className="relative mx-2 my-3 flex basis-1/3 flex-row content-around lg:my-4"
      role="search"
    >
      <label htmlFor={searchInputId} className="sr-only">
        {t("search_placeholder")}
      </label>
      <input
        id={searchInputId}
        type="search"
        name="q"
        className="box-border w-full rounded-full border border-solid border-gray-300 py-3 pr-10 pl-5 font-sans text-base text-black placeholder:text-gray-600/100"
        placeholder={t("search_placeholder")}
      />

      <div className="absolute inset-y-0 right-3 flex items-center">
        <button
          aria-label={t("search")}
          type="submit"
          value="Search"
          className="mt-px flex cursor-pointer items-center justify-center border-none bg-transparent text-gray-800"
        >
          <Search name="Search" role="search" className="size-6" aria-hidden="true" />
        </button>
      </div>
    </form>
  )
}
